export class SuperAdminContextModel {

  private static storageKey = 'superAdminContext';

  schoolId: string;
  schoolName: string;
  returnUrl: string;

  static getContext(): SuperAdminContextModel {
    const json = localStorage.getItem(this.storageKey);
    if (!json) { return null; }
    const data = JSON.parse(json);
    const ctx = new SuperAdminContextModel();
    ctx.schoolId = data.schoolId;
    ctx.schoolName = data.schoolName;
    ctx.returnUrl = data.returnUrl;
    return ctx;
  }

  static setContext(schoolId: string, schoolName: string, returnUrl: string) {
    const ctx = { schoolId, schoolName, returnUrl };
    localStorage.setItem(this.storageKey, JSON.stringify(ctx));
  }

  static removeContext() {
    localStorage.removeItem(this.storageKey);
  }

  static isActive(): boolean {
    return localStorage.getItem(this.storageKey) !== null;
  }

}
